// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/store_config.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Int32Value, proto3, StringValue, Timestamp } from "@bufbuild/protobuf";
import { PaymentCollectionType } from "../../enum/v1/payment_collection_type_pb.js";

/**
 * @generated from message fingertip.common.type.v1.StoreConfig
 */
export const StoreConfig = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreConfig",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "application_fee", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "updated_at", kind: "message", T: Timestamp },
    { no: 9, name: "tax_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "tax_id_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "pass_through_payment_fee", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "invoice_memo", kind: "message", T: StringValue },
    { no: 13, name: "invoice_footer", kind: "message", T: StringValue },
    { no: 14, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "invoice_business_name", kind: "message", T: StringValue },
    { no: 23, name: "stripe_linked_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "show_bank_account_details", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "banking_instructions", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "booking_policy", kind: "message", T: StringValue },
    { no: 16, name: "host_details", kind: "message", T: StringValue },
    { no: 17, name: "payment_collection_type", kind: "enum", T: proto3.getEnumType(PaymentCollectionType) },
    { no: 18, name: "late_cancellation_fee_percent", kind: "message", T: Int32Value },
    { no: 19, name: "cancellation_grace_period_in_hours", kind: "message", T: Int32Value },
    { no: 20, name: "no_show_fee_percent", kind: "message", T: Int32Value },
    { no: 21, name: "deposit_percent", kind: "message", T: Int32Value },
  ],
);

